/**
 * Permission V2 frontend helpers.
 *
 * user.PagePms = { PageCd: Mode } (1=read, 2=edit), user.PageReg = registered PageCds.
 * Both are null for legacy sessions / un-migrated branches -> fall back to the old
 * Pms-code gating. Pages not in PageReg (e.g. branch pages not seeded yet) are
 * treated as unrestricted.
 */

export const hasPagePerm = (user, pageCd, mode = 1) => {
  if (!user || !user.PagePms || !user.PageReg) return true
  if (!user.PageReg.includes(pageCd)) return true
  return (user.PagePms[pageCd] || 0) >= mode
}

const legacyVisible = (user, pmStr) => {
  if (!pmStr) return true
  return !!user.Pms.find(pm => pmStr.split(";").includes(pm.Code) && pm.Mode > 0)
}

/** Should a menu child item be shown? */
export const pageVisible = (user, child, header) => {
  if (user.PagePms && user.PageReg && user.PageReg.includes(child.page)) {
    return (user.PagePms[child.page] || 0) >= 1
  }
  return legacyVisible(user, (child && child.permission) || (header && header.permission) || "")
}

/** Should a menu header (and its section) be shown? */
export const headerVisible = (user, header) => {
  if (user.PagePms && user.PageReg) {
    return header.children.some(child => !child.hide && pageVisible(user, child, header))
  }
  return legacyVisible(user, header.permission || "")
}
